import type { TableView } from 'owa-mail-list-store';
import { isGroupTableQuery } from 'owa-group-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getIsArchivePolicyEnabled(tableView: TableView): boolean {
    if (tableView && isGroupTableQuery(tableView.tableQuery)) {
        return false;
    }

    return !!getUserConfiguration().SessionSettings.HasArchive;
}
